/**
 * Journal entry source types (BE-16 JournalSourceType): label and chip colour, and the filter groups of the
 * Journal Entries list. Every type sits in exactly one group.
 */

export const SOURCE_COLORS = {
  MANUAL: { bg: '#7c3aed', label: 'Manual' },
  BANK_TRANSFER: { bg: '#0e7490', label: 'Bank transfer' },
  INVOICE: { bg: '#3b82f6', label: 'Invoice' },
  CREDIT_NOTE: { bg: '#be185d', label: 'Credit Note' },
  RECEIPT: { bg: '#047857', label: 'Receipt' },
  SETTLEMENT: { bg: '#059669', label: 'Settlement' },
  WALLET_TOPUP: { bg: '#0891b2', label: 'Wallet Top-up' },
  WALLET_REFUND: { bg: '#6366f1', label: 'Wallet Refund' },
  RECEIVED_CHEQUE: { bg: '#0d9488', label: 'Received Cheque' },
  VAT_PAYMENT: { bg: '#7e22ce', label: 'VAT Payment' },
  SUBSCRIPTION_PAYMENT: { bg: '#0369a1', label: 'Subscription' },
  PLATFORM_PAYMENT: { bg: '#0e7490', label: 'Thaklis Payment' },
  EXPENSE: { bg: '#ef4444', label: 'Expense' },
  CHEQUE: { bg: '#65a30d', label: 'Cheque' },
  COMMISSION: { bg: '#f59e0b', label: 'Commission' },
  COMMISSION_PAYMENT: { bg: '#d97706', label: 'Commission Payment' },
  CC_CHARGE: { bg: '#e11d48', label: 'Card Charge' },
  CC_PAYMENT: { bg: '#9f1239', label: 'Card Payment' },
  GOVT_FEE: { bg: '#b45309', label: 'Govt Fee' },
  WORK_ORDER_ADDON: { bg: '#a16207', label: 'Work-Order Add-on' },
  FINE: { bg: '#b91c1c', label: 'Fine' },
  PARTNER_BILL: { bg: '#4f46e5', label: 'Partner Bill' },
  PARTNER_WALLET: { bg: '#4338ca', label: 'Partner Wallet' },
  PARTNER_PAYMENT: { bg: '#3730a3', label: 'Partner Payment' },
  DEPRECIATION: { bg: '#6b7280', label: 'Depreciation' },
  REVERSAL: { bg: '#475569', label: 'Reversal' },
  VAT_RETURN: { bg: '#6d28d9', label: 'VAT Return' },
  OPENING_BALANCE: { bg: '#334155', label: 'Opening Balance' },
  DRAWING: { bg: '#78716c', label: 'Drawing' },
  RECONCILIATION: { bg: '#57534e', label: 'Reconciliation' },
};

export const sourceInfo = (type) => SOURCE_COLORS[type] || { bg: '#6b7280', label: type };

// Category → its source types; 'ALL' means no source filter.
export const SOURCE_GROUPS = [
  { value: 'ALL', label: 'All', types: [] },
  { value: 'REVENUE', label: 'Revenue', types: ['INVOICE', 'CREDIT_NOTE'] },
  { value: 'PAYMENTS', label: 'Payments', types: ['RECEIPT', 'SETTLEMENT', 'WALLET_TOPUP', 'WALLET_REFUND', 'RECEIVED_CHEQUE', 'VAT_PAYMENT', 'SUBSCRIPTION_PAYMENT', 'PLATFORM_PAYMENT'] },
  { value: 'EXPENSES', label: 'Expenses', types: ['EXPENSE', 'CHEQUE', 'COMMISSION', 'COMMISSION_PAYMENT', 'CC_CHARGE', 'CC_PAYMENT', 'GOVT_FEE', 'WORK_ORDER_ADDON', 'FINE'] },
  { value: 'PARTNERS', label: 'Partners', types: ['PARTNER_BILL', 'PARTNER_WALLET', 'PARTNER_PAYMENT'] },
  { value: 'ASSETS', label: 'Assets', types: ['DEPRECIATION'] },
  { value: 'MANUAL', label: 'Manual', types: ['MANUAL'] },
  { value: 'OTHER', label: 'Other', types: ['REVERSAL', 'VAT_RETURN', 'OPENING_BALANCE', 'DRAWING', 'RECONCILIATION', 'BANK_TRANSFER'] },
];
